// src/planner/FloatingActionButton.js
import React from 'react';
import styled from 'styled-components';
import { color, font } from '../../theme/tokens';

// Anchored to the bottom-left of the planner board (PageContainer is position: relative)
const FAB = styled.button`
    position: absolute;
    bottom: 24px;
    left: 24px;
    z-index: 40;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    min-height: 48px;
    padding: 0 22px 0 18px;
    border: 1px solid ${color.blood};
    border-radius: 0;
    background: ${color.blood};
    color: ${color.onBlood};
    font-family: ${font.display};
    font-weight: 800;
    font-size: 15px;
    letter-spacing: 0.3em;
    cursor: pointer;
    box-shadow: 0 8px 24px rgba(7, 2, 5, 0.6);
    transition: background-color 0.25s ease, border-color 0.25s ease;

    .plus { font-family: ${font.mono}; font-weight: 400; font-size: 20px; letter-spacing: 0; line-height: 1; }

    &:hover {
        background: ${color.bloodHi};
        border-color: ${color.bloodHi};
    }
`;

function FloatingActionButton({ onClick }) {
    return (
        <FAB type="button" onClick={onClick}>
            <span className="plus" aria-hidden="true">+</span>新建
        </FAB>
    );
}

export default FloatingActionButton;
